<template>
    <header>
        <nav class="navbar fixed-top navbar-expand-lg scrolling-navbar top-nav-collapse bg-white" style="z-index: 10;">
            <div class="nav-contact navbar-expand pl-2">
                <ul class="navbar-nav mr-auto justify-content-start text-white pl-0 pr-0">
                    <li class="nav-item d-none d-sm-none d-md-none d-lg-block">
                        <p class="mb-0 mt-1 p-1">1autorent</p>
                    </li>
                    <span class="mt-2 d-none d-sm-none d-md-none d-lg-block">|</span>
                    <li class="nav-item d-none d-sm-none d-md-block">
                        <p class="mb-0 mt-1 p-1">Autorent OÜ</p>
                    </li>
                    <span class="mt-2 d-none d-sm-none d-md-block">|</span>
                    <li class="nav-item d-none d-sm-block">
                        <p class="mb-0 p-1 pt-md-2 pt-lg-2">Türi 6, Tallinn</p>
                    </li>
                    <span class="mt-2 d-none d-sm-block">|</span>
                    <li class="nav-item d-none d-sm-block">
                        <p class="mb-0 p-1 pt-md-2 pt-lg-2">{{ $t('Mon-Fri') }} 8.30-20.30, {{ $t('Sat-Sun') }} 10.00-20.30</p>
                    </li>
                    <span class="mt-2 d-none d-sm-block">|</span>
                    <li class="nav-item">
                        <a href="tel:+372 53 555 999" class="text-white contact mb-0 p-1 pt-md-2 pt-lg-2">+372 53 555 999</a>
                    </li>
                    <span class="mt-2">|</span>
                    <li class="nav-item">
                        <a href="mailto:info@1autorent.ee" class="text-white contact mb-0 p-1 pt-md-2 pt-lg-2">info@1autorent.ee</a>
                    </li>
                </ul>
                <div class="d-none d-sm-none d-md-block">
                    <ul class="navbar-nav ml-auto justify-content-end">
                        <li class="nav-item">
                            <a class="nav-link lang text-white border border-light waves-effect" @click="setLocale('et')">
                                EST
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link lang text-white border border-light waves-effect" @click="setLocale('en')">
                                ENG
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="nav-container navbar-light">
                <p class="navbar-brand-mobile">
                    <router-link to="/">
                        <img height="75px" src="~@assets/img/1autorent-www_color.svg" alt="">
                    </router-link>
                </p>

                <button class="navbar-toggler"
                        :class="{'collapsed': !mobileMenuOpen}"
                        type="button"
                        :aria-expanded="!mobileMenuOpen"
                        aria-label="Toggle navigation"
                        @click="closeMenu">
                    <span class="navbar-toggler-icon"/>
                </button>

                <div class="navbar-collapse collapse" :class="{'show': mobileMenuOpen}" id="mobileNav">
                    <ul class="navbar-nav pl-0 text-uppercase">
                        <li class="nav-item d-block d-sm-none mb-4">
                            <div class="d-flex justify-content-between">
                                <a class="nav-link border px-4" @click="setLocale('et')">
                                    EST
                                </a>
                                <a class="nav-link border px-4" @click="setLocale('en')">
                                    ENG
                                </a>
                                <div class="nav-link border px-3 rounded" @click="closeMenu">
                                    X
                                </div>
                            </div>
                        </li>
                        <li class="nav-item">
                            <router-link to="/" class="nav-link" exact @click="closeMenu">
                                {{ $t('Home') }}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name:'prices'}" class="nav-link">
                                {{ $t('Prices') }}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name:'renting'}" class="nav-link">
                                {{ $t('Renting') }}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name:'specials'}" class="nav-link">
                                {{ $t('Special offers') }}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name:'contact'}" class="nav-link">
                                {{ $t('Contact') }}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <a href="https://1paadirent.ee" target="_blank" class="nav-link">
                                {{ $t('Boat rent') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="https://1matkaautorent.ee" target="_blank" class="nav-link">
                                {{ $t('Camper rent') }}
                            </a>
                        </li>
                    </ul>
                    <div class="mt-4 d-block d-sm-none" style="padding-left: 6px;">
                        <p class="mb-1">Autorent OÜ</p>
                        <p class="mb-1">Türi 6, Tallinn</p>
                        <p class="mb-1">{{ $t('Mon-Fri') }} 8.30-20.30</p>
                        <p class="mb-1">{{ $t('Sat-Sun') }} 10.00-20.30</p>
                    </div>
                    <div class="collapse mob-menu" id="navbarSupportedContent">
                        <ul class="navbar-nav my-auto">
                            <li class="nav-item mt-2">
                                <fa-icon :icon="['fas', 'mobile-alt']" />
                                <p class="contact ">+372 53 555 999 </p>
                            </li>
                            <li class="nav-item">
                                <fa-icon :icon="['far', 'envelope']" />
                                <p class="contact ">info@1autorent.ee </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <a href="#!" class="collapse navbar-collapse-overlay"></a>
                <router-link to="/" class="navbar-brand" exact>
                    <img height="75px" src="~@assets/img/1autorent-www_color.svg" alt="">
                </router-link>
            </div>
        </nav>
    </header>
</template>

<script>
import AuthService from '@services/auth.service';

export default {
    name: 'AppNav',
    data() {
        return {
            mobile_menu_open: false
        };
    },
    computed: {
        mobileMenuOpen() {
            return this.mobile_menu_open;
        },
        isAuthorized() {
            return AuthService.isAuthorized;
        }
    },
    methods: {
        setLocale(locale) {
            if (this.$i18n.locale !== locale) {
                this.$store.dispatch('SET_LOCALE', locale).then(() => {
                    this.selectedLocale = locale;
                }).catch(() => {
                    if (locale !== 'en') {
                        this.setLocale('en');
                    }
                });
            }
        },
        closeMenu() {
            this.mobile_menu_open = !this.mobile_menu_open;
        }
    },
};
</script>
